import { supabase } from "../supabase";

/** Fetch all trees owned by or shared with the current user. */
export async function fetchMyTrees() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return { trees: [], error: null };

  const { data, error } = await supabase
    .from("trees")
    .select(`
      *,
      tree_members!left(role, user_id)
    `)
    .or(`owner_id.eq.${user.id},tree_members.user_id.eq.${user.id}`)
    .order("created_at");

  return { trees: data ?? [], error };
}

/** Create a new tree owned by the current user. */
export async function createTree(name, isPrivate = false) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return { tree: null, error: new Error("Not authenticated") };

  const { data, error } = await supabase
    .from("trees")
    .insert({ name, owner_id: user.id, is_private: isPrivate })
    .select()
    .single();

  return { tree: data, error };
}

/** Update a tree (name, is_private). Only the owner can do this. */
export async function updateTree(treeId, updates) {
  const { data, error } = await supabase
    .from("trees")
    .update(updates)
    .eq("id", treeId)
    .select()
    .single();
  return { tree: data, error };
}

/** Delete a tree and all its people (cascades via FK). */
export async function deleteTree(treeId) {
  const { error } = await supabase.from("trees").delete().eq("id", treeId);
  return { error };
}
